import React from 'react';
import { OnboardingNudgeErrorBoundary } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { FEEDBACK_NUDGE_ID } from '../../common/constants.tsx';
import type { WrapperProps } from '../../common/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const FeedbackNudgeLazy = lazyAfterPaint(
	() =>
		import(/* webpackChunkName: "async-feedback-onboarding-nudge" */ './index').then(
			(exportedModule) => exportedModule.FeedbackNudge,
		),
	{
		ssr: false,
	},
);

export const FeedbackNudgeAsync = ({ children }: WrapperProps) => (
	<OnboardingNudgeErrorBoundary
		id={FEEDBACK_NUDGE_ID}
		fallback={children}
		attributes={{
			nudgeId: FEEDBACK_NUDGE_ID,
		}}
	>
		<Placeholder name="feedback-onboarding-nudge" fallback={children}>
			<FeedbackNudgeLazy>{children}</FeedbackNudgeLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);

FeedbackNudgeAsync.displayName = 'FeedbackNudgeAsync';
